import React, { ReactElement } from "react";

import { makeStyles, Tooltip } from "@material-ui/core";
import { TooltipProps } from "@material-ui/core/Tooltip/Tooltip";

export interface CustomTooltipProps {
  children: ReactElement;
  title?: string;
  customColor?: string;
}

export const useCustomTooltipStyles = makeStyles(
  (theme) => ({
    arrow: {
      color: theme.palette.common.black,
    },
    tooltip: {
      backgroundColor: theme.palette.common.black,
      fontSize: 12,
    },
  }),
  {
    name: "custom-tooltip-style",
    flip: null,
  }
);
export const CustomTooltip = (props: CustomTooltipProps | TooltipProps) => {
  const classes = useCustomTooltipStyles(props);

  return (
    <Tooltip arrow classes={classes} {...(props as TooltipProps)}>
      {props.children}
    </Tooltip>
  );
};
